module.exports = __webpack_public_path__ + "static/logo-meiquer-labs-ef374f12890c519b96e3cb26eaddd6a1.svg";